import { FC, PropsWithChildren } from 'react';

import { SubscriptionLockScreen } from './SubscriptionLockScreen';
import { useSubscriptionStore } from './useSubscriptionStore';

export const SubscriptionLockScreenProvider: FC<PropsWithChildren> = ({ children }) => {
  const { isSubscriptionActive, variant } = useSubscriptionStore();

  if (!isSubscriptionActive) {
    return <SubscriptionLockScreen variant={variant} />;
  }

  return children;
};
